/**
 * @fileoverview GET handler for the "/engagement/content_blocks/territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksTerritories } from "./constants";
import type { EngagementContentBlocksTerritoriesResult } from "./types";

export const getEngagementContentBlocksTerritories = reactQueryFetcherAdapter(
  engagementContentBlocksTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementContentBlocksTerritoriesResult> => {
    return fetch(`/engagement/content_blocks/territories`, "GET", { app_group_id: appGroupId }, { signal });
  }
);
